<template lang="pug">
.community-list(:class="{'is-spread': isSpread, 'is-dtl-show': isDetailShow}")
  .toggle-btn(@click="toggleCtn")
    template(v-if="!isSpread")
      i.el-icon-caret-left
      span 小区详情
    i.el-icon-caret-right(v-else)
  .top
    span
      span.pre 小区:
      | {{topData(1)}}个
    span
      span.pre 屏幕:
      | {{topData(2)}}个
    span(v-show="numShow")
      span.pre 人群:
      | {{topData(3)}}
    //- span(:title="topData(4) + '人'" v-show="numShow")
      span.pre 日均客流量:
      | {{topData(4)}}人

  .no-dist(v-show="list.length == 0")
    div 暂无记录
    div 快去智能筛选吧~

  .list.fl.content_box(v-show="list.length > 0" ref="listCtn" id="listCtn" :class="{'is-one-star': !numShow}" @scroll="scroll")
    div(:style="{'height': `${itemHeight*(list.length)}px`, 'position': 'relative'}")
      div(:style="{'position': 'absolute','width':'100%', 'top': `${top}px`}")
        .item(
          v-for="(item, i) in showList" :key="i" @click="showLineDetail(item, i, true)"
          :class="{'cur': currentExpandvillage && item.guid == currentExpandvillage.guid}"
        )
          el-checkbox.fl(v-model="item.check" @click.stop.native="()=>{}" @change="checkChange(item)" ref="cml" :indeterminate="item.indeterminate" :disabled="item.disabled")
          .name(v-if="!isSpread") {{item.name}}
          div(v-else)
            .fl
              img(:src="item.url")
              .matchDeg(
                :class="['match' + (item.match ? Math.floor(Math.round((item.match - 0) * 100)/20) : '')]"
              ) 匹配度：{{item.match ? Math.round((item.match - 0) * 100) : 0}}%
            .fl.list-main
              .name {{item.name}}
                span(v-if="item.location") {{item.location}}
              .detail
                //- span(v-if="item.tradeArea") {{item.tradeArea}}
                span(v-if="item.place_type") {{item.place_type}}
                span(v-if="item.housesPrice") 房屋均价: ￥{{item.housesPrice}}/㎡
                span(v-if="item.maintenanceCharge") 物业费: ￥{{(item.maintenanceCharge - 0).toFixed(2)}}/㎡
              .detail
                span(v-if="item.buildingNumber") {{ buildUnit(item) }}

              .fee
                .fl
                  | 总价:
                  span.int.Akrobat-ExtraBold ￥{{fee(allDeviceMoney(item))}}
                  span.int.Akrobat-ExtraBold .{{fee(allDeviceMoney(item), 1)}}
                .fl.mr 梯内:
                  span.int.Akrobat-ExtraBold ￥{{fee(item.price)}}
                  span.int.Akrobat-ExtraBold .{{fee(item.price, 1)}}
                  span.unit /屏/天
                .fl.mr 梯外:
                  span.int.Akrobat-ExtraBold ￥{{fee(item.price)}}
                  span.int.Akrobat-ExtraBold .{{fee(item.price, 1)}}
                  span.unit /屏/天
                .fr
                  | 屏幕:
                  span.num.Akrobat-ExtraBold {{jisuan([item])}}
                  span.amount.Akrobat-ExtraBold /{{item.allDevices.length}}

                .clear
          .clear
  .screenSel.fl(v-show="isSpread && isDetailShow")
    .title
      .tab-ctn
        .device_type
          .half(
            v-for="(item, i) in ['梯内屏', '梯外屏']" :key="i"
            :class="{'cur': curShowDeviceType === i}" @click="curShowDeviceType = i"
          ) {{item}}
            .num.Akrobat(style="margin-left: 5px;") {{sortAllDeviceNum(i, 1)}}/
              span.Akrobat {{sortAllDeviceNum(i)}}
      .close.fr
        i.el-icon-close(@click="screenSelDetail")
      .clear
      .checkbox(v-if="lineDetail && lineDetail.length > 0")
        el-checkbox(v-model="isDeviceTypeStatus.check" @change="screenChooseAll" :indeterminate="isDeviceTypeStatus.half") 全选
      .data-none(v-if="!lineDetail || lineDetail.length === 0") {{'暂无梯' + (curShowDeviceType === 1 ? '外' : '内') + '屏哦~'}}
    .bd_list
      .detail(v-for="(item, index) in lineDetail" :key="index")
        .de-title
          .fl
            el-checkbox.fl(v-model="item.check" @change="blockChose(item)" :indeterminate="item.indeterminate" :disabled="item.disabled")
            span.floor {{item.building}}
            span.recommend(v-if="!item.canSelect") （缺货）
            span.recommend(v-else) （推荐度{{item.recommend | tofix}}%）
          .fr
            .hasChose.fl
              | 已选屏幕：
              span.num.Akrobat-ExtraBold {{jisuan(item.unitDeviceList)}}
              span.amount.Akrobat-ExtraBold /{{item.allDeviceCount}}
            .close.fr
              i.el-icon-arrow-up(
                @click="item.open = !item.open"
                :class="{'no-open': !item.open}"
              )
        .de-detail(v-for="(unitDevice, ind) in item.unitDeviceList" :key="ind" v-show="item.open")
          .unit.fl {{unitDevice.unit}}
          .numLift.fr
            .lift_detail.fl(v-for="(device, i) in unitDevice.deviceList" :key="i")
              el-checkbox.fl(v-model="device.check" @change="ladNumChose(device)" :disabled="device.disabled")
              //- span {{device.deviceName}}({{device.recommend | tofix}}%)
              span {{device.deviceName}}
              span(v-if="!device.canSelect") （缺货）
              span(v-else) ({{device.recommend | tofix}}%)
        .clear
  .btm
    .sort.fl
      el-checkbox.checkbox(v-model="checkAll" @change="checkAllChange" :indeterminate="listIndeterminate") 全部
      span 合计金额:
      span.sumCount.Akrobat-ExtraBold ￥{{fee(finalPay)}}.{{fee(finalPay, 1)}}
      span.disCount.Akrobat-ExtraBold(v-if="showDisPrice") ￥{{fee(allTotalDeviceMoney)}}.{{fee(allTotalDeviceMoney, 1)}}
    .btn.fr(@click="send")
      template(v-if="isSpread") 立即投放
      template(v-else)
        .fl(style="margin-left: 15px;margin-right: 0;") 投放
        .fl(style="line-height: 1;width: 110px;margin-right: 0;text-align: center;")
          .els.Akrobat-ExtraBold(
            style="font-size: 18px;"
            :style="{marginTop: showDisPrice ? '5px' : '13px'}"
          ) ￥{{fee(finalPay)}}.{{fee(finalPay, 1)}}
          .els.Akrobat-ExtraBold(
            style="font-size: 12px;text-decoration: line-through;margin-left: 15px;"
            v-if="showDisPrice"
          ) ￥{{fee(allTotalDeviceMoney)}}.{{fee(allTotalDeviceMoney, 1)}}

  fix-center.fix-recharge(ref="setPwd" w="400" h="300")
    template(slot="title") 温馨提醒
    .c(slot="main" style="text-align: center;line-height: 150px;")
      div 需要认证资质才能继续
    template(slot="btm")
      .fix-btn.red(@click="goUrl('/accountInfo')") 去认证
      .fix-btn(@click="$refs.setPwd.hide()") 先看看

</template>

<script>
import { deepClone } from '@/utils/functions'

export default {
  name: 'map-community-list',
  filters: {
    people(v) {
      if (!v) return 0
      else if (v > 10000) return v / 10000 + '万'
      else return v
    },
    tofix(v, num) {
      if (!v) return 0
      return Math.round((v - 0) * 100)
    }
  },
  data() {
    return {
      list: [],
      idx: 1,
      showList: [],  //可视区域显示的数据
      contentHeight: 500,  //可视区域高度
      itemHeight: 37,      //每条数据所占高度
      showNum: 22,  //可是区域显示的最大条数
      top: 0, //偏移量
      scrollTop: 0,  //卷起的高度
      startIndex: 0,  //可视区域第一条数据的索引
      endIndex: 0,  //可视区域最后一条数据后面那条数据的的索引
      isSpread: false,
      isDetailShow: false,
      checkAll: false,
      currentExpandvillage: {}, // 当前展开的小区
      lineDetail: [], // 右侧小区详情
      screenChosed: 0, // 已选屏幕数量
      discountList: [],
      listIndeterminate: false,
      curShowDeviceType: 0,
      isDeviceTypeStatus: {
        check: false, half: false
      }
    }
  },
  computed: {
    // 搜索结果小区原始数据列表
    searchResult() {
      return this.$store.state.bmap.searchDetail
    },
    customer() {
      return this.$store.state.customer.customerInfo
    },
    // 楼栋数-单元数-户数
    buildUnit() {
      return m => {
        let { buildingNumber, unitNumber, housesNumber } = m
        if (!buildingNumber) return ''
        return `${buildingNumber}栋楼-${unitNumber}单元` + (housesNumber && housesNumber > -1 ? '-' + housesNumber + '户' : '')
      }
    },
    sortAllDeviceNum() {
      let currentExpandvillage = this.currentExpandvillage
      if (!currentExpandvillage) return 0
      return (idx, type) => { // type传1代表只计算选中的
        let key = idx === 1 ? 'twBuildDeviceList' : 'buildDeviceList'
        let keyList = currentExpandvillage[key]
        if (!keyList || keyList.length === 0) return 0
        let data = this.getAllDevice(this.currentExpandvillage[key] || [], key)
        return type ? data.filter(el => el.check).length : data.length
      }
    },
    jisuan() {
      return list => this.getAllDevice(list).filter(el => el.check).length
    },
    fee() {
      return (money, type) => {
        if (!money) return type ? '00' : 0
        let isMinus = money < 0
        if (isMinus) money = 0 - money
        if (!type) {
          let arr = (Math.floor(money) + '').split('').reverse()
          let a = []
          arr.forEach((el, i) => {
            a.push(el)
            if ((i + 1) % 3 == 0) a.push(',')
          })
          let str = a.reverse().join('')
          let data = str.charAt(0) == ',' ? str.slice(1) : str
          return isMinus ? '-' + data : data
        } else {
          let sp = ((money - 0).toFixed(2) + '').split('.')
          if (sp.length <= 1) return '00'
          return (sp[1] + '').length == 1 ? sp[1] + '0' : sp[1]
        }
      }
    },
    totalMoney() {
      return this.list.filter(el => el.check).reduce((a, b) => a + (b.slotAmount ? b.slotAmount - 0 : 0), 0)
    },
    checkedItems() {
      this.list.forEach(el => {
        let allDeviceList = this.getConcatDeviceList(el)
        this.$set(el, 'allDevices', this.getAllDevice(allDeviceList))
        this.$set(el, 'allCanCheckDevices', el.allDevices)
      })
      return this.list.filter(el => el.allCanCheckDevices.filter(el => el.check).length > 0)
    },
    allTotalDeviceMoney() {
      return this.list.filter(el => el.check || el.indeterminate).reduce((a, b) => {
        return a + b.allDevices.filter(el => el.check).reduce((c, d) => c + d.amount, 0)
      }, 0)
    },
    allDeviceMoney() {
      return w => {
        return this.getAllDevice([w])
          .filter(e => e.check).reduce((a, b) => a - 0 + b.amount, 0).toFixed(2)
      }
    },
    topData() {
      let items = this.checkedItems
      return type => {
        if (type == 1) return items.length
        else if (type == 2) {
          return items.reduce((cur, next) => {
            return cur - 0 + (next.allDevices.filter(el => el.check).length - 0)
          }, 0)
        } else if (type == 3) {
          if (items.length == 0) return 0
          let data = items.map(el => el.audienceNumber).reduce((cur, next) => cur - 0 + (next - 0), 0)
          if (isNaN(data) || data < 0) return -1
          data = data - 0
          return data > 10000 ? (data / 10000).toFixed(2) + '万' : data
        } else if (type == 4) {
          if (items.length == 0) return 0
          let data = items.map(el => el.dailyFlow || 0).reduce((cur, next) => cur - 0 + (next - 0), 0)
          if (isNaN(data) || data < 0) return -1
          data = data - 0
          return data > 10000 ? (data / 10000).toFixed(2) + '万' : data
        }
        return 0
      }
    },
    numShow() {
      let data = (this.list || []).map(el => el.audienceNumber || 0).reduce((cur, next) => cur - 0 + (next - 0), 0)
      return data >= 0
    },
    showDisPrice() {
      return this.discountMoney > 0
    },
    discountMoney() {
      if (this.discountList.length == 0) return 0
      let discount = 1
      this.discountList.forEach(m => {
        if (m.limit < this.allTotalDeviceMoney && discount > m.sale) discount = m.sale
      })
      return ((1 - discount) * 100) * (this.allTotalDeviceMoney * 100) / 10000
    },
    finalPay() {
      return (this.allTotalDeviceMoney - this.discountMoney).toFixed(2)
    }
  },
  watch: {
    searchResult: {
      deep: true,
      handler(v) {
        const nbhds = deepClone(v)
        if (!nbhds || nbhds.length == 0) {
          this.isDetailShow = false
          this.isSpread = false
          this.listIndeterminate = false
          this.list = []
        } else {
          this.disableNum = 0
          if (nbhds.length > 0) this.checkAll = true
          this.initList(nbhds)
          if (this.disableNum > 0) {
            this.listIndeterminate = true
            this.checkAll = false
          }
          this.list = nbhds

          // 设置地图渲染用的小区基础数据
          const basics = []
          for (let j = 0; j < nbhds.length; j++) {
            const { guid, name, match, lon, lat, check, indeterminate } = nbhds[j]
            basics.push({
              guid,
              name,
              lon,
              lat,
              check,
              indeterminate,
              match
            })
          }
          window._nbhds = basics
          this.$store.commit('setSearchBasic', basics.map(({ guid: id, check }) => { return {id, check} }))
        }
      }
    },
    list: {
      immediate: true,
      handler(nv) {
        if (nv && nv.length > 0) {
          this.scroll()
          this.$nextTick(() => {
            this.$refs['cml'].forEach(cbox => {
              cbox.$el.onclick = event => {
                event.stopPropagation()
              }
            })
          })
        }
      }
    },
    curShowDeviceType(v) {
      if (v < 0) return
      let curNbhdData = this.currentExpandvillage
      this.lineDetail = v === 1 ? (curNbhdData.twBuildDeviceList || []) : (curNbhdData.buildDeviceList || [])
      this.$forceUpdate()
    },
    lineDetail: {
      deep: true,
      handler() {
        this.$nextTick(_ => {
          let data = this.getAllDevice(this.currentExpandvillage[this.getDeviceTypeKey()] || [])
          let checkL = data.filter(el => el.check).length
          this.isDeviceTypeStatus.check = data.length === checkL
          this.isDeviceTypeStatus.half = !!(checkL < data.length && checkL > 0)
        })
      }
    },
    isSpread(v) {
      this.itemHeight = v ? 130 : 37
    },
  },
  beforeDestroy() {
    this.$root.$off('mapListSpreadClose')
    this.$root.$off('mapListChooseItem')
    this.$root.$off('mapSeniorSift')
  },
  created() {
    this.getDiscountList()
    this.$root.$on('mapListSpreadClose', () => {
      this.isSpread = false
      this.isDetailShow = false
      this.currentExpandvillage = {}
    })
    this.$root.$on('mapListChooseItem', nbhdId => {
      this.isSpread = false
      this.$root.$emit('mapSearchListSpread')
      const aim = this.list.filter(e => e.guid === nbhdId)[0]
      this.showLineDetail(aim, null, true)
    })
    this.$root.$on('mapSeniorSift', this.handleSeniorSift)

    /**
     ** @deprecated 废弃功能: 点击地图中小区marker的勾选/去勾选图标,右侧列表相应小区的勾选状态同步响应
      *! 2023-11-03: 此功能原版本就未实现,地图引擎由百度转为高德后,为保证大量小区数据情况下地图渲染、拖动等操作不卡顿
      *! 用于地图渲染的小区数据需使用普通变量存储，即要与Vue脱钩(不作属性响应式劫持,减少不必要的响应式计算)
      ** 参考(https://blog.csdn.net/jifashihan/article/details/128231939)
      */
    // this.$root.$on('mapNbhdChooseChange', data => {
    //   let item = this.list.filter(el => el.guid == data.guid)[0]
    //   if (!item) return
    //   this.lineDetail = []
    //   this.showLineDetail(item)
    //   this.$nextTick(() => {
    //     let idx = this.list.map(el => el.guid).indexOf(data.guid)
    //     const delay = setTimeout(() => {
    //       clearTimeout(delay)
    //       this.updateSelectedStatus(item, 'buildDeviceList')
    //       this.updateSelectedStatus(item, 'twBuildDeviceList')
    //       document.getElementById('listCtn').scrollTo(0, idx * (this.isSpread ? 129 : 37))
    //     }, 210)
    //   })
    // })
  },
  methods: {
    // 高级筛选 --- start
    /**
     * type 当前选中项,0: 未选屏幕数量及推荐度 1: 按屏幕数量筛选 2: 按推荐度筛选
     * curNum  屏幕数量, type=0时为null, type=1时为屏幕数量,type=2时为推荐度
     * snFilter 屏幕类型 true代表只选了梯内屏或梯外屏, false 代表不限屏幕类型
     * snTn 屏幕类型是否选择梯内屏
     * snTw 屏幕类型是否选择梯外屏
     */
    handleSeniorSift({ type, curNum, snFilter, snTn, snTw }) {
      // console.log('高级筛选:', type, curNum, snTn, snTw)
      if (type === 0) { // 不限
        const liftAll = this.list.reduce((a, b) => a.concat(b.allDevices || []), [])
        liftAll.forEach((f) => {
          this.$set(f, 'check', true)
        })
        this.handleSnTypeChoose(type, curNum, snFilter, snTn, snTw)
      } else {
        if (!snFilter) { // 屏幕类型"不限"
          if (type === 1) { // 按屏幕数筛选
            this.changeDeviceNumCheckNbhdFirst(curNum)
          }
          if (type === 2) { // 按推荐度筛选
            this.filterMatchCheck(curNum)
          }
        } else { // 选择了梯内屏或梯外屏
          this.handleSnTypeChoose(type, curNum, snFilter, snTn, snTw)
        }
      }

      // 根据小区对象下的所有点位勾选状态更新小区自身的 勾选/半选 状态
      this.list.forEach(m => {
        if (!m.allDevices) return
        const allL = m.allDevices.length
        const checkNum = m.allDevices.filter(e => e.check).length
        this.$set(m, 'check', checkNum === allL ? true : false)
        this.$set(m, 'indeterminate', checkNum < allL && checkNum > 0 ? true : false)
      })

      // 更新地图渲染用的小区基础数据
      const basics = this.list.map(({ guid, name, match, lon, lat, check, indeterminate }) => {
        return {
          guid,
          name,
          lon,
          lat,
          check,
          indeterminate,
          match
        }
      })
      window._nbhds = basics
      this.$store.commit('setSearchBasic', basics.map(({ guid: id, check }) => { return {id, check} }))
    },
    handleSnTypeChoose(type, aimNum, isSnTypeFilter, tnSift, twSift) {
      if (type === 0) { // 只需要过滤梯内梯外屏
        if (!isSnTypeFilter) { // 不限,全选上
          this.list.forEach(nbhd => {
            nbhd.allDevices.forEach(t => {
              if (!t.check) {
                this.$set(t, 'check', true)
              }
            })
          })
        } else { // 仅选择梯内或梯外屏
          this.list.forEach(nbhd => {
            // 梯内屏根据tnSift变化
            nbhd.buildDeviceList && nbhd.buildDeviceList.forEach(bd => {
              bd.allDevices.forEach(dc => {
                if (tnSift && !dc.check) {
                  this.$set(dc, 'check', true)
                }
                if (!tnSift && dc.check) {
                  this.$set(dc, 'check', false)
                }
              })
            })
            // 处理梯外屏
            nbhd.twBuildDeviceList && nbhd.twBuildDeviceList.forEach(bd => {
              bd.allDevices.forEach(dc => {
                if (twSift && !dc.check) {
                  this.$set(dc, 'check', true)
                }
                if (!twSift && dc.check) {
                  this.$set(dc, 'check', false)
                }
              })
            })
          })
        }
      }
      if (type === 1) { // 多少个梯内梯外屏
        if (!isSnTypeFilter) { // 不限屏幕类型
          this.changeDeviceNumCheckNbhdFirst(aimNum)
        } else {
          this.changeDeviceNumCheckNbhdFirst(aimNum, tnSift)
        }
      }
      if (type === 2) { // 筛选大于指定推荐度的屏幕
        if (!isSnTypeFilter) { // 不限屏幕类型
          this.filterMatchCheck(aimNum)
        } else {
          this.filterMatchCheck(aimNum, tnSift)
        }
      }
    },
    changeDeviceNumCheckNbhdFirst(snNum, chooseTn) {
      const data = this.list
      let detailDevices = []
      if (chooseTn !== undefined) {
        // 去除所有的梯内/梯外屏集合
        detailDevices = data.reduce((res, cur) => res.concat(this.nbhdDevicesTnorTw(cur, chooseTn)), [])
        // 未选择屏幕的类型的点位取消勾选
        data.forEach(t => {
          this.changeItemsCheckStatus(this.getBuildingList(t, !chooseTn), false)
        })
      } else {
        detailDevices = data.reduce((a, b) => a.concat(b.allDevices || []), [])
      }

      const needChooseIds = detailDevices.slice(0, snNum).map(x => x.deviceGuid)
      data.forEach(nbhd => {
        nbhd.allDevices.forEach(lift => {
          let isChooseThis = needChooseIds.indexOf(lift.deviceGuid) > -1
          if (isChooseThis && !lift.check) {
            this.$set(lift, 'check', true)
          }
          if (!isChooseThis && lift.check) {
            this.$set(lift, 'check', false)
          }
        })
      })
    },
    /**
     * 获取某个小区的所有梯内屏或梯外屏
     * @param {Object} m 小区数据对象
     * @param {Boolean} isTn true:梯内屏, false:梯外屏
     */
    nbhdDevicesTnorTw(m, isTn) {
      const list = this.getBuildingList(m, isTn)
      return list.reduce((res, cur) => res.concat(cur.allDevices || []), [])
    },
    // 获取小区的梯内或梯外数组
    getBuildingList(dto, isTn) {
      return isTn ? dto['buildDeviceList'] || [] : dto['twBuildDeviceList'] || []
    },
    // 设置arr中所有对象的勾选/取消勾选
    changeItemsCheckStatus(arr, bool) {
      (arr || []).forEach(x => {
        if (x.check !== bool) {
          this.$set(x, 'check', bool)
        }
      })
    },
    /**
     * 按推荐度筛选电梯/屏幕
     * @param {Number} aimDegree 目标推荐度
     * @param {Boolean} chooseTn true:按梯内屏推荐度筛选, false:按梯外屏推荐度筛选
     */
    filterMatchCheck(aimDegree, chooseTn) {
      this.list.forEach((nbhd) => {
        // 按设备的推荐度进行匹配勾选
        this.filterDeviceMatch(nbhd, aimDegree, chooseTn)
      })
    },
    filterDeviceMatch(nto, aimDegree, chooseTn) {
      if (chooseTn !== undefined) {
        const typeDevices = this.nbhdDevicesTnorTw(nto, chooseTn)
        typeDevices.forEach(d => {
          this.matchDeviceRecommend(d, aimDegree)
        })
        this.changeItemsCheckStatus(this.nbhdDevicesTnorTw(nto, !chooseTn), false)
      } else {
        nto.allDevices.forEach(d => {
          this.matchDeviceRecommend(d, aimDegree)
        })
      }
    },
    /**
     * 按电梯/屏幕推荐度进行匹配
     * @param {Object} aDevice 电梯/屏幕数据对象
     * @param {Number} aimDegree 需要匹配的推荐度
     */
    matchDeviceRecommend(aDevice, aimDegree) {
      const dRec = Number((aDevice.recommend * 100).toFixed(2))
      if (dRec < aimDegree && aDevice.check) {
        this.$set(aDevice, 'check', false) // 小于目标推荐度的取消勾选
      } else if (dRec >= aimDegree && !aDevice.check) {
        this.$set(aDevice, 'check', true) // 大于目标推荐度的勾选上
      }
    },
    // 高级筛选 --- end

    initList(tmp, parent) {
      let checked = 0 // checked: 0-未选 / 0.5-半选 / 1-全选
      tmp.forEach(dto => {
        if (parent) dto.parent = parent
        if (dto.deviceGuid && !dto.canSelect) this.disableNum += 1

        dto.allDevices = this.getItemAllDevice(dto) // 初始化每一项所有的allDevices

        dto.disabled = false // 放开canSelect的限制
        this.$set(dto, 'indeterminate', false)

        const cList = this.getChildList(dto)
        if (cList && cList.length > 0) {
          let ck = this.initList(cList, dto)
          this.$set(dto, 'indeterminate', ck === 0.5)
          this.$set(dto, 'check', ck > 0)
          checked += ck
        } else {
          this.$set(dto, 'check', dto.canSelect)
          checked += dto.canSelect ? 1 : 0
        }
        if (dto.unitDeviceList) {
          this.$set(dto, 'open', true)
        }
      })
      if (checked === 0) {
        return 0
      } else if (checked < tmp.length) {
        return 0.5
      } else {
        return 1
      }
    },
    //计算可视区域数据
    getShowList() {
      this.startIndex = Math.floor(this.scrollTop / this.itemHeight)
      this.endIndex = this.startIndex + this.showNum
      this.showList = this.list.slice(this.startIndex, this.endIndex)
      const offsetY = this.scrollTop - (this.scrollTop % this.itemHeight)
      this.top = offsetY
    },
    //监听滚动事件
    scroll() {
      this.scrollTop = document.querySelector('.content_box').scrollTop
      this.getShowList()
    },
    getDeviceTypeKey() {
      return this.curShowDeviceType === 1 ? 'twBuildDeviceList' : 'buildDeviceList'
    },
    clearList() {
      this.isSpread = false
      this.isDetailShow = false
      this.currentExpandvillage = {}
      this.screenChosed = 0
      this.lineDetail = []
    },
    async getDiscountList() {
      let response = await this.fetch('/boss/common/config/v2/getDiscountActivity', '', 'get')
      this.discountList = response.data || []
    },
    setParentStatus(data) { // 递归改变父级以及父级的父级的 check 和 indeterminate 的属性值
      const _p = data.parent
      this.setItemStatus(_p)
      if (_p.parent) this.setParentStatus(_p)
    },
    setItemStatus(item) { // 根据 item 的 allDevices 来计算 item 的 check 和 indeterminate 的属性值
      if (!item.allDevices || item.allDevices.length === 0) item.allDevices = this.getAllDevice(this.getChildList(item))
      const all = item.allDevices
      const allL = all.length
      const checkNum = all.filter(e => e.check).length
      const ckNew = checkNum === allL ? true : false
      const partial = checkNum > 0 && checkNum < allL ? true : false
      if (item.guid) {
        // 小区勾选状态变更消息(半选时小区marker也是高亮状态,故半选变为全选不视作状态变化)
        // (1)由全选/半选变为 不勾选
        if (((item.check && !item.indeterminate) || (!item.check && item.indeterminate)) && !ckNew && !partial) {
          console.log('全选/半选 变为不选', item.check, item.indeterminate, ckNew, partial)
          this.noticeMap({ guid: item.guid, check: ckNew, indeterminate: partial })
        }
        // (2)由不勾选 变为全选/半选
        if (!item.check && !item.indeterminate && (ckNew || partial)) {
          console.log('不选 变为全选/半选', item.check, item.indeterminate, ckNew, partial)
          this.noticeMap({ guid: item.guid, check: ckNew, indeterminate: partial })
        }
      }
      // item.check = ckNew
      // item.indeterminate = partial
      this.$set(item, 'check', ckNew)
      this.$set(item, 'indeterminate', partial)
    },
    updateSelectedStatus(data, listName) {
      if (data[listName]) this.setChildrenCheckedStatus(data, listName) // 存在子节点
      if (data.parent) this.setParentStatus(data) // 存在父节点
      this.handleCheckAllStatus() // 最外层底部全选的状态变化
    },
    handleCheckAllStatus() {
      const devicesAll = this.list.reduce((a, b) => a.concat(b.allDevices), [])
      const checkedNum = devicesAll.filter(e => e.check).length // 已勾选的电梯/点位数
      if (checkedNum === devicesAll.length) {
        this.checkAll = true
        this.listIndeterminate = false
      } else {
        this.checkAll = false
        if (checkedNum > 0) this.listIndeterminate = true
        else this.listIndeterminate = false
      }
    },
    setChildrenCheckedStatus(data, listName) {
      if (!data[listName] || !data[listName].length) return
      let checked = 0
      for (let i = 0; i < data[listName].length; i++) {
        if (!data[listName][i].disabled) {
          data[listName][i].check = data.check
        }
        checked += data[listName][i].check
        if (listName === 'buildDeviceList') this.setChildrenCheckedStatus(data[listName][i], 'unitDeviceList')
        else if (listName === 'twBuildDeviceList') this.setChildrenCheckedStatus(data[listName][i], 'unitDeviceList')
        else if (listName === 'unitDeviceList') this.setChildrenCheckedStatus(data[listName][i], 'deviceList')
      }
      if (checked > 0 && checked < data[listName].length) data.indeterminate = true
      else data.indeterminate = false
    },
    getChildList(item) {
      if (item.hasOwnProperty('buildDeviceList') || item.hasOwnProperty('twBuildDeviceList')) {
        return this.getConcatDeviceList(item)
      } else {
        return item.deviceList || item.unitDeviceList || []
      }
    },
    toggleCtn() {
      this.isSpread = !this.isSpread
      if (!this.isSpread) {
        this.isDetailShow = false
        this.scrollToIndex(37)
      } else {
        this.$root.$emit('mapSearchListSpread')
      }
    },
    screenSelDetail() {
      this.isDetailShow = false
    },
    scrollToIndex(height) {
      const tt = setTimeout(() => {
        clearTimeout(tt)
        document.getElementById('listCtn').scrollTo(0, this.idx * height)
      }, 240)
    },
    showLineDetail(val, index, isScroll) {
      this.idx = this.list.map(el => el.guid).indexOf(val.guid)
      if (isScroll && !this.isSpread) {
        this.scrollToIndex(129)
      }
      this.isSpread = false
      this.isDetailShow = false
      this.curShowDeviceType = -1
      this.$nextTick(() => {
        this.currentExpandvillage = val
        this.screenChosed = this.getAllDevice([val]).length
        this.curShowDeviceType = 0
        this.isSpread = true
        this.isDetailShow = true
      })

      val.allDevices.forEach(el => { // 更新可能没变化的父级状态
        this.setParentStatus(el.parent)
      })
    },
    handleChoose(arr, flag, keyName) {
      if (flag) {
        arr.forEach(el => {
          el.canSelect = true
          el[keyName].forEach(ele => {
            ele.canSelect = true
          })
        })
      } else {
        arr.forEach(el => {
          el.canSelect = false
          el[keyName].forEach(ele => {
            ele.canSelect = false
          })
        })
      }
    },
    getAllDevice(arr, key) {
      return [].concat.apply([], arr.map(t => this.getItemAllDevice(t)))
    },
    getItemAllDevice(dt) { // 初始化递归所有数据时调用
      if (dt.allDevices && dt.allDevices.length) return dt.allDevices // 已存在直接取不进行递归运算,减少重复计算
      if (dt.deviceGuid) {
        dt.allDevices = [dt]
        return dt.allDevices
      } else {
        return [].concat.apply([], this.getChildList(dt).map(p => this.getItemAllDevice(p)))
      }
    },
    getConcatDeviceList(item) {
      return [].concat(item.buildDeviceList || []).concat(item.twBuildDeviceList || [])
    },
    async send() {
      // 当前客户审核状态不是生效中
      if (this.customer.advertiserType && this.customer.checkStatus !== 1) {
        await this.$store.dispatch('customer/getCustomerInfo') // 更新一次客户信息
        if (this.customer.checkStatus !== 1) {
          this.$refs.setPwd.show()
          return
        }
      }

      const allLift = this.getAllDevice(this.list)
      if (allLift.length == 0 || allLift.filter(e => e.check).length == 0) {
        return this.messageTip('请选择小区点位')
      }
      let data = this.list.map(el => {
        el.allDevices = this.getAllDevice(this.getConcatDeviceList(el)) // 存储每个小区所有的设备
        el.allCanCheckDevices = el.allDevices
        return el
      })
      // emit 存在选择设备的小区列表
      this.$emit('confirm', data.filter(f => f.allDevices.length > 0 && f.allDevices.filter(f => f.check).length > 0))
    },
    // 发出自定义事件，通知地图更新小区渲染
    noticeMap(detail) {
      document.dispatchEvent(new CustomEvent('mapupdate', {
        bubbles: true,
        cancelable: true,
        composed: true,
        detail
      }))
    },
    // 小区选择
    checkChange(n, e) {
      this.updateSelectedStatus(n, 'buildDeviceList')
      this.updateSelectedStatus(n, 'twBuildDeviceList')
      this.noticeMap({ guid: n.guid, check: n.check, indeterminate: n.indeterminate })
    },
    // 小区详情中的梯内屏/梯外屏全选操作(功能同上）
    screenChooseAll() {
      // 处理子集的变化，
      // check 状态保存在 isDeviceTypeStatus 中，第一个传参 在 当前对象 currentExpandvillage 的基础上扩展出 isDeviceTypeStatus 的 check 属性值
      this.updateSelectedStatus({ ...this.currentExpandvillage, check: this.isDeviceTypeStatus.check }, this.getDeviceTypeKey())
      this.setItemStatus(this.currentExpandvillage) // 处理当前对象的变化
    },
    // 幢选择
    blockChose(b) {
      this.updateSelectedStatus(b, 'unitDeviceList')
    },
    // 梯号选择
    ladNumChose(d) {
      this.updateSelectedStatus(d)
    },
    checkAllChange() {
      const that = this
      if (this.checkAll) this.listIndeterminate = false
      this.list.forEach(e => {
        e.allDevices.forEach(lift => {
          if (lift.check != this.checkAll) {
            lift.check = this.checkAll
            // that.$set(lift, 'check', this.checkAll)
          }
        })
      })
      this.$nextTick(() => {
        this.list.forEach(t => {
          that.setItemStatus(t)
          that.$nextTick(() => {
            that.setChildrenCheckedStatus(t, 'buildDeviceList')
            that.setChildrenCheckedStatus(t, 'twBuildDeviceList')
          })
        })
      })
    }
  }
}
</script>

<style lang="sass">
.time-slot.el-popper
    border: 1px solid #282729
</style>

<style lang="sass" scoped>
.time-slot-popper
    width: 380px
    margin: 10px
    .time-slot-item
        display: inline-block
        margin: 5px
        width: 100px
        height: 30px
        border: 1px solid #E9E9E9
        color: #999
        text-align: center
        line-height: 28px
        position: relative
        cursor: pointer
        &.choose
            color: #282729
            border: 1px solid #282729
        img
            position: absolute
            top: 0
            right: 0
            width: 12px

    .submit-btn
        width: 80px
        height: 30px
        line-height: 30px
        text-align: center
        margin: 5px
        font-size: 14px
        &.white
            background: #fff
            border: 1px solid #e9e9e9
            color: #282729
.no-dist
    margin-top: 200px
    text-align: center
    font-weight: 400
    line-height: 20px

    img
        width: 112px
        margin-bottom: 10px
.community-list
    height: 100%
    width: 160px
    // border-bottom: 1px solid #e9e9e9
    min-height: 500px
    position: relative
    border-right: 1px solid #e9e9e9
    &.is-spread
        width: 620px
        &.is-dtl-show
            min-width: 931px
        .top
            width: 100%
            // border-right: 1px solid #E9E9E9
        .list
            height: calc(100% - 71px)
            overflow: auto
            width: 619px

            // +
            > div
                width: 100%

            .item
                width: 100%
                padding: 10px 0
                .el-checkbox
                    margin: 50px 10px 0 10px
            .name
                font-size: 16px
        .sort
            display: block
    .sort
        display: none

    .toggle-btn
        $bcolor: #E9E9E9
        $hcolor: #F8E71C
        position: absolute
        width: 20px
        height: 110px
        margin-top: -55px
        top: 50%
        left: -20px
        background: $bcolor
        cursor: pointer
        text-align: center
        // border-radius: 10px 0 0 10px
        border-top-left-radius: 4px
        border-bottom-left-radius: 4px
        &:hover
            background: $hcolor
            i.el-icon-caret-left
                display: none
            span
                display: block
            &::after
                background: -webkit-radial-gradient(0% 100%, transparent 70%, $hcolor 70%)
            &::before
                background: -webkit-radial-gradient(0% 0%, transparent 70%, $hcolor 70%)

        i
            margin-top: 50px
        span
            margin-top: 20px
            display: none
        &::after
            position: absolute
            bottom: -10px
            right: 0
            width: 10px
            height: 10px
            content: ''
            display: block
            background: -webkit-radial-gradient(0% 100%, transparent 70%, $bcolor 70%)
        &::before
            position: absolute
            top: -10px
            right: 0
            width: 10px
            height: 10px
            content: ''
            display: block
            background: -webkit-radial-gradient(0% 0%, transparent 70%, $bcolor 70%)
    .top
        border-bottom: 1px solid #e9e9e9
        font-size: 12px
        font-weight: 500
        color: #282729
        line-height: 30px
        width: 160px
        overflow: hidden
        > span
            max-width: 160px
            padding-left: 15px
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            word-break: break-all
            height: 30px
        span
            color: #282729
            margin-right: 30px
            display: inline-block
            float: left
            &.pre
                margin-right: 5px
                // margin-left: 20px
    .list
        height: calc(100% - 161px)
        overflow: auto

        // +
        width: 100%
        text-align: center
        > div
            margin: 0 auto
            width: 140px
            text-align: left

        &.is-one-star
            height: calc(100% - 101px)
        .item
            padding: 5px 0
            border-bottom: 1px solid #E9E9E9
            cursor: pointer
            &:hover, &.cur
                background-color: #f1f1f1
                .detail
                    span
                        background-color: #FFFFFF
            .el-checkbox
                margin-right: 10px
                margin-top: 2px
            img
                width: 90px
                height: 90px
                margin-right: 10px
            .matchDeg
                width: 90px
                height: 20px
                background: #FF3973
                border-radius: 0 0 4px 4px
                color: #FFFFFF
                font-size: 12px
                font-weight: 400
                line-height: 16px
                // padding: 2px 0 0 8px
                padding-top: 3px
                text-align: center
                margin-top: -5px
                &.match0, &.match
                    background: rgba(26, 25, 28, 0.7)
                &.match1
                    background: rgba(74, 59, 76, 0.4)
                &.match2
                    background: rgba(129, 72, 116, 0.6)
                &.match3
                    background: rgba(187, 68, 123, 0.8)
                &.match4, &.match5
                    background: rgba(237, 81, 127, 1)

            .fl.list-main
                width: calc(100% - 140px)
            .name
                line-height: 1
                margin-bottom: 3px
                font-weight: 600
                font-size: 14px
                line-height: 22px
                span
                    font-size: 12px
                    color: #999
                    margin-left: 5px

            .detail
                font-size: 12px
                line-height: 20px
                min-height: 20px
                margin-bottom: 5px
                span
                    margin-right: 5px
                    background-color: #F5F5F5
                    color: #666
                    padding: 2px 6px
                    display: inline-block
                    height: 24px

            .fee
                color: #999
                width: 100%
                // line-height: 1
                margin-top: 5px
                font-size: 14px
                .mr
                    margin-left: 20px
                .unit
                    font-weight: bold
                    line-height: 20px
                    color: #282729
                span
                    color: #FF3973
                    &.int
                        font-size: 16px
                        font-weight: 600
                .fr
                    margin-right: 15px
                    .num
                        font-size: 16px
                    .amount
                        font-size: 16px
                        color: #282729
                .btn
                    display: inline-block
                    width: 15px
                    height: 15px
                    line-height: 15px
                    text-align: center
                    color: #fff
                    margin: 0 5px
                    background: #FF3973
                    cursor: pointer
                    &.disable
                        background: #e9e9e9
                        cursor: not-allowed
    .screenSel
        width: 310px
        height: calc(100% - 70px)
        padding: 0 10px
        border-left: 1px solid #E9E9E9
        font-size: 12px
        overflow-y: auto
        .title
            margin: 0 -10px
            height: 80px
            font-size: 14px
            line-height: 20px
            position: relative
            .hasChose
                margin-left: 10px
                .num
                    color: #FF3973
                    font-weight: 600
                .amount
                    color: #282729
                    font-weight: 600
            .close
                cursor: pointer
                position: absolute
                top: 11px
                right: 15px
            .tab-ctn
                border-bottom: 1px solid #e9e9e9
                overflow: hidden
            .device_type
                width: 270px
                float: left
                text-align: center
                height: 40px
                line-height: 20px
                padding: 10px
                cursor: pointer
                .half
                    width: 50%
                    display: inline-block
                    color: #999
                    border-right: 1px solid #e9e9e9
                    &.cur
                        font-weight: 600
                        color: #282729
                        .num
                            span
                                color: #999
                    .num
                        display: inline-block
                        span
                            color: #999
            .checkbox
                height: 40px
                padding-top: 10px
                border-bottom: 1px solid #e9e9e9
                padding: 10px
        .data-none
            line-height: 80px
            background: #F5F5F5
            margin: 10px
        .bd_list
            height: calc(100% - 80px)
            overflow: auto
            padding: 10px 0
        .detail
            background-color: #F5F5F5
            margin-bottom: 6px
            border-bottom: 1px solid #E9E9E9
            .de-title
                padding: 6px 0 0 10px
                height: 30px
                border-bottom: 1px solid #E9E9E9
            .floor
                font-size: 14px
                font-weight: 500
            .recommend
                font-weight: 500
            .fl
                .floor
                    margin-left: 10px
            .fr
                .hasChose
                    margin-right: 10px
                    .num
                        color: #FF3973
                        font-weight: 600
                    .amount
                        color: #282729
                        font-weight: 600
                .close
                    cursor: pointer
                    margin-right: 5px
                    .el-icon-arrow-up
                        &.no-open
                            transform: rotate(180deg)
            .de-detail
                display: inline-block
                padding: 6px 0 0 10px
                .unit
                    width: 50px
                    margin-top: 5px
                    font-weight: 600
                .numLift
                    width: 220px
                    .lift_detail
                        width: 50%
                        margin: 5px 0
                        span
                            margin-left: 5px
    @-moz-document url-prefix()  //firfox
        .screenSel
            width: 309px !important

    .btm
        position: absolute
        z-index: 2
        bottom: -1px
        left: 1px
        border-top: 1px solid #e9e9e9

        width: 100%
        background: #fff
        line-height: 40px
        .sort
            margin-left: 10px
            .checkbox
                width: 70px
                display: inline-block
                margin-right: 10px
            span
                font-size: 14px
            .sumCount
                color: #FF3973
                font-size: 16px
                font-weight: bold
            .disCount
                text-decoration: line-through
                margin-left: 10px
        span
            font-size: 20px
            &.small
                font-size: 14px
        .fl
            margin-right: 10px

        .btn
            float: right
            width: 160px
            height: 40px
            line-height: 40px
            background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
            font-weight: 400
            text-align: center
            color: #fff
            cursor: pointer
</style>
